import {BaseRouteMetaDataModel} from "../../../infrastructure/models/route/base-route.meta-data.model";

export class AccumulatorRouteMetaDataModel extends BaseRouteMetaDataModel {

  get pageTitle() {
    return 'accumulator title';
  }

  get description() {
    return 'accumulator description'
  }
}